'use client'

type VerifiedCheckBadgeProps = {
  size?: number
  className?: string
}

/** Verified listing badge — Blue/500 `#4A90E2`. */
export default function VerifiedCheckBadge({
  size = 24,
  className = '',
}: VerifiedCheckBadgeProps) {
  return (
    <span
      className={`pointer-events-none block shrink-0 overflow-visible ${className}`}
      style={{ width: size, height: size, minWidth: size, minHeight: size, aspectRatio: '1 / 1' }}
      aria-label="Verified"
      title="Verified"
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="block h-full w-full"
        aria-hidden
      >
        <path
          d="M10.2627 1.87988C11.2353 1.04853 12.7758 1.05349 13.7529 1.87695L13.7588 1.88184L15.3389 3.24219L15.3408 3.24316C15.4038 3.29778 15.5332 3.37622 15.7051 3.44043C15.8768 3.50456 16.0259 3.53027 16.1104 3.53027H17.8096C19.2837 3.53027 20.49 4.73591 20.4902 6.20996V7.91016C20.4902 7.98855 20.515 8.13731 20.5801 8.3125C20.6451 8.48741 20.7234 8.61743 20.7764 8.67871L20.7783 8.68066L22.1387 10.2607L22.1396 10.2627C22.9713 11.2353 22.9672 12.7767 22.1436 13.7539L22.1387 13.7598L20.7783 15.3398L20.7764 15.3418C20.7218 15.4049 20.6442 15.5336 20.5801 15.7051C20.5159 15.8769 20.4902 16.0259 20.4902 16.1104V17.8105C20.4901 19.2847 19.2837 20.4902 17.8096 20.4902H16.1104C16.0319 20.4902 15.8824 20.5159 15.707 20.5811C15.532 20.6462 15.4019 20.7244 15.3408 20.7773L15.3389 20.7783L13.7588 22.1387L13.7568 22.1406C12.7842 22.972 11.2437 22.9671 10.2666 22.1436L10.2607 22.1387L8.68066 20.7783L8.67871 20.7773C8.61569 20.7227 8.48632 20.6443 8.31445 20.5801C8.14302 20.5161 7.99459 20.4903 7.91016 20.4902H6.17969C4.70564 20.4901 3.50013 19.2846 3.5 17.8105V16.1006C3.5 16.0227 3.4746 15.8763 3.41016 15.7021C3.34772 15.5335 3.27216 15.4032 3.21777 15.3359L1.86816 13.7461L1.86621 13.7432C1.0517 12.7742 1.0517 11.2463 1.86621 10.2773L1.86816 10.2744L3.21777 8.68457C3.27216 8.61727 3.34774 8.48697 3.41016 8.31836C3.47457 8.14425 3.5 7.99784 3.5 7.91992V6.2002C3.50006 4.7261 4.7056 3.52061 6.17969 3.52051H7.91016C7.98868 3.52045 8.13734 3.49477 8.3125 3.42969C8.44383 3.38088 8.5496 3.32469 8.62012 3.27734L8.68262 3.23047L10.2627 1.87988Z"
          fill="#4A90E2"
          stroke="white"
          strokeWidth="1.5"
        />
        <path
          d="M10.7896 15.1703C10.5896 15.1703 10.3996 15.0903 10.2596 14.9503L7.83957 12.5303C7.54957 12.2403 7.54957 11.7603 7.83957 11.4703C8.12957 11.1803 8.60957 11.1803 8.89957 11.4703L10.7896 13.3603L15.0896 9.06027C15.3796 8.77027 15.8596 8.77027 16.1496 9.06027C16.4396 9.35027 16.4396 9.83027 16.1496 10.1203L11.3196 14.9503C11.1796 15.0903 10.9896 15.1703 10.7896 15.1703Z"
          fill="white"
        />
      </svg>
    </span>
  )
}
